<template>
  <h2 class="counter">
    <span ref="numEl">{{ display }}</span>
    <slot name="symbol"></slot>
  </h2>
</template>

<script>
export default {
  name: "Counter",
  props: {
    from: {
      type: Number,
      default: 0
    },
    to: {
      type: Number,
      required: true
    },
    comma: {
      type: Boolean,
      default: false
    },
    duration: {
      type: Number,
      default: 2000 // ms
    },
    refreshInterval: {
      type: Number,
      default: 25 // ms
    }
  },
  data() {
    return {
      display: this.comma
          ? this.from.toLocaleString()
          : this.from.toString()
    }
  },
  mounted() {
    const observer = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting) {
        observer.disconnect()
        this.animate()
      }
    })

    observer.observe(this.$refs.numEl)
  },
  methods: {
    animate() {
      const loops = Math.ceil(this.duration / this.refreshInterval)
      const increment = (this.to - this.from) / loops
      let value = this.from
      let loopCount = 0

      const interval = setInterval(() => {
        value += increment
        loopCount++

        const output = loopCount >= loops ? this.to : value
        this.display = this.comma
            ? Math.round(output).toLocaleString()
            : Math.round(output).toString()

        if (loopCount >= loops) clearInterval(interval)
      }, this.refreshInterval)
    }
  }
}
</script>

<style scoped>
.counter {
  font-size: 3rem;
  font-weight: 600;
}
</style>